import mainStyle from "../mainStyle.module.scss";
import React, { useState, useEffect } from 'react';
import { cloneDeep } from "lodash";
import { useOutletContext, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { TextField, InputAdornment, Grid, Box, Typography, Button, Divider, Tooltip } from "@mui/material";
import { useTheme, styled } from "@mui/material/styles";
import infoTipIcon from "assets/images/icons/icn_Info_solid.svg";
import infoTipHoverIcon from "assets/images/icons/icn_info_solid_hover.svg";

import btn_alert from "assets/images/icons/btn_alert.svg";
import btn_alert_light from "assets/images/icons/btn_alert_light.svg";
import btn_general from "assets/images/icons/btn_general.svg";
import btn_general_light from "assets/images/icons/btn_general_light.svg";

import { ReactComponent as LeaveIcon } from "assets/images/icons/icn_table_cell_Launch.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin_red.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show.svg";
import { ReactComponent as UnverifiedIcon } from "assets/images/icons/icn_table_cell_Unverified.svg";
import { ReactComponent as AddIcon } from "assets/images/icons/icn_table_cell_Add.svg";
import { ReactComponent as AddHoverIcon } from "assets/images/icons/icn_table_cell_Add_hover.svg";

// Service
import { useUserContext } from 'contexts/UserContext';
import { useBreadStorageContext } from 'contexts/BreadStorageContext';
import useDataSourceManager from "hooks/useDataSourceManager";

import ModalContainer from 'components/ModalContainer';
import ModalforCheck from '../modalCheck.js';
import ModalConfirmPw from "../modalConfirmPw";
import Notifications from "./Notifications";

import { MenuSelect } from "components/Select/menuSelect";
import AutocompleteSelect from "components/Select/AutocompleteSelect";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";

import { getCountryList, getTimezoneList } from "utils/timezone";
import { validateDeviceAccount, validateDeviceAccountPassword } from 'utils/validate';

const passwordRequirementsTip = (
  <Box sx={{ fontSize: "14px", lineHeight: 1.5 }}>
    <Typography sx={{ fontSize: "14px", fontWeight: 700, mb: 0.5 }}>
      Password Requirements
    </Typography>
    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
      <li>8–30 characters</li>
      <li>At least 1 uppercase letter (A–Z)</li>
      <li>At least 1 lowercase letter (a–z)</li>
      <li>At least 1 number (0–9)</li>
      <li>At least 1 special character (~ ! @ # $ ^ &amp; * &#123; &#125; [ ] ( ) _ - + = . | : ; &apos; &quot; &lt; , &gt; / \)</li>
      <li>No consecutive identical characters (e.g., 11, aa, 22)</li>
    </Box>
  </Box>
);

const checkMockup = process.env.REACT_APP_IS_MOCKUP;

const StyledIconButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.transparent,
  width: "22px",
  height: "22px",
  minWidth: "16px",
  padding: "0",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.transparent,
  },
}));

const ManageOrgLevel = () => {
  const { scopeData, setScopeData, scopeReady } = useOutletContext();
  const { bread, setBread } = useBreadStorageContext();
  const { userState } = useUserContext();
  const navigate = useNavigate();

  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } = useDataSourceManager();

  const [nowAnchor, setNowAnchor] = useState('account');
  const handleAnchor = (section) => {
    setNowAnchor(section)
  }

  const [nowScope, setNowScope] = useState('');
  const [checkScopeName, setCheckScopeName] = useState(true);

  const [showEditGeneral, setShowEditGeneral] = useState(true);
  const [showLeaveGeneral, setShowLeaveGeneral] = useState(true);
  const [showDeleteGeneral, setShowDeleteGeneral] = useState(true);
  // const [showInventory, setShowInventory] = useState(true);

  const [openModalConfirmPw, setOpenModalConfirmPw] = useState(false);
  const [openModalCheck, setOpenModalCheck] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState('');
  const [modalSaveBtn, setModalSaveBtn] = useState('');
  const [modalCancelBtn, setModalCancelBtn] = useState('');
  const [originUser, setOriginUser] = useState('');
  // for modalCheck to check from where
  const [modalFrom, setModalFrom] = useState('');

  const [updateNameUuid, _setUpdateNameUuid] = useState(uuidv4());
  const [deleteNameUuid, _setDeleteNameUuid] = useState(uuidv4());
  const [leaveNameUuid, _setLeaveNameUuid] = useState(uuidv4());
  const [readInventoryUuid, _setReadInventoryUuid] = useState(uuidv4());
  const [updateInventoryUuid, _setUpdateInventoryUuid] = useState(uuidv4());

  const [nowUuid, setNowUuid] = useState('');

  const [isAddHovered, setIsAddHovered] = useState(false);
  const [showDevicePw, setShowDevicePw] = useState(false);
  const [userError, setUserError] = useState("");
  const [userPWError, setUserPWError] = useState("");

  const [readOrgGeneralUuid, _setReadOrgGeneralUuid] = useState(uuidv4());
  const [updateOrgGeneralUuid, _setUpdateOrgGeneralUuid] = useState(uuidv4());

  // 原始資料
  const [originalInfoData, setOriginalInfoData] = useState({});
  const [originalCountryDomainData, setOriginalCountryDomainData] = useState({});
  const [originalTimezoneList, setOriginalTimezoneList] = useState([]);
  const [originalTimezoneData, setOriginalTimezoneData] = useState({});
  const [originalNtpServers, setOriginalNtpServers] = useState([]);
  const [originalInventoryDeviceAccountData, setOriginalInventoryDeviceAccountData] = useState({});
  // 當前填入的資料
  const [scopeName, setScopeName] = useState('');
  const [selectCountryList, setSelectCountryList] = useState([]);
  const [selectCountry, setSelectCountry] = useState({});
  const [timezoneList, setTimezoneList] = useState([]);
  const [selectTimezoneData, setSelectTimezoneData] = useState({});
  const [ntpServers, setNtpServers] = useState([]);
  const [inventoryName, setInventoryName] = useState('');
  const [inventoryPW, setInventoryPW] = useState('');

  useEffect(() => {
    if (userState) {
      setOriginUser(userState)
    }
  }, [userState]);

  useEffect(() => {
    let nowSelectedBread = JSON.parse(
      localStorage.getItem("selectBreadcrumbs") || "{}"
    );
    if ((Object.keys(nowSelectedBread).length !== 0 && scopeReady) || checkMockup === 'true') {
      // manage org
      setShowLeaveGeneral(false)
      setShowDeleteGeneral(false)
      setShowEditGeneral(false)

      setNowScope('Organization')
      // setScopeName(nowSelectedBread.orgs.name) // super & admin 
      // if(nowSelectedBread.orgs.roleId === 5 || nowSelectedBread.orgs.roleId === 6){
      //   setShowEditGeneral(true)
      // }
      // if(nowSelectedBread.realm.roleId === 1 || nowSelectedBread.realm.roleId === 2){
      //   setShowEditGeneral(true)
      //   setShowDeleteGeneral (true)
      // }else if(nowSelectedBread.realm.roleId === 4){
      //   setShowEditGeneral(true)
      //   setShowLeaveGeneral (true)
      // }
      // setShowEditGeneral(false)

      if (nowSelectedBread.realm.roleId === 1 || nowSelectedBread.realm.roleId === 2) {
        if (nowSelectedBread.orgs.roleId === 5 || nowSelectedBread.orgs.roleId === 6) {
          setShowEditGeneral(true)
          setShowDeleteGeneral(true)
          if (nowSelectedBread.orgs.roleId === 8) {
            setShowDeleteGeneral(false)
            setShowLeaveGeneral(true)
          }
        }
      }
      // readInventory()
    }
  }, [scopeReady]);

  useEffect(() => {
    if (nowScope === 'Organization') {
      const tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

      const restfulParams = {
        entId: tmpSelectedBread.realm.id,
        orgId: tmpSelectedBread.orgs.id
      }

      sendRequest("/ents/:entId/orgs/:orgId/settings/general.read", readOrgGeneralUuid, restfulParams);
    }
  }, [nowScope])

  // dataMap 先分開做 未來有機會一次整合全部的 dataMap 行為
  useEffect(() => {
    const response = getData(readOrgGeneralUuid);
    if (response && response.data) {
      const { info, countryDomain, timeConfig, inventoryDeviceAccount } = response.data;

      setOriginalInfoData(info)
      setScopeName(info.orgName)

      const currentSelectCountryList = getCountryList();
      setSelectCountryList(currentSelectCountryList)

      const currentCountry = currentSelectCountryList.find((item) => item.value === countryDomain.countryIndex)
      setOriginalCountryDomainData(currentCountry)
      setSelectCountry(currentCountry);

      const timezoneList = getTimezoneList(countryDomain.countryIndex);
      setOriginalTimezoneList(timezoneList)
      setTimezoneList(timezoneList)
      const currentTimezoneData = timezoneList.find((item) => item.value === timeConfig.timezone)
      setOriginalTimezoneData(currentTimezoneData)
      setSelectTimezoneData(currentTimezoneData)

      const formattedData = [timeConfig.ntpServer1, timeConfig.ntpServer2, timeConfig.ntpServer3].filter(Boolean);
      setOriginalNtpServers(formattedData)
      setNtpServers(formattedData)

      setOriginalInventoryDeviceAccountData(inventoryDeviceAccount);
      setInventoryName(inventoryDeviceAccount.userName)
      setInventoryPW(inventoryDeviceAccount.password)
    }
  }, [dataMap])

  useEffect(() => {
    if (selectCountry && selectCountry.value) {
      const timezoneList = getTimezoneList(selectCountry.value);
      setTimezoneList(timezoneList);

      if (selectCountry.value === originalCountryDomainData.value && originalTimezoneData) {
        setSelectTimezoneData(originalTimezoneData);
      } else {
        setSelectTimezoneData(timezoneList[0]);
      }
    }
  }, [selectCountry])

  function handleAddNtpServer() {
    if (ntpServers.length < 3) {
      setNtpServers([...ntpServers, ""]);
    }
  }

  function handleDeleteNtpServer(index) {
    const updated = ntpServers.filter((_, i) => i !== index);
    setNtpServers(updated);
  }

  function handleChangeNtpServer(value, index) {
    const updated = [...ntpServers];
    updated[index] = value;
    setNtpServers(updated);
  }

  const handleInput = (e, key) => {
    let tmpVal = e.target.value;
    switch (key) {
      case "scopeName":
        setScopeName(tmpVal)
        break;
      case "inventoryName":
        setInventoryName(tmpVal)
        const userErrorResult = validateDeviceAccount(tmpVal);
        setUserError(userErrorResult.valid ? "" : userErrorResult.msg);
        break;
      case "inventoryPW":
        setInventoryPW(tmpVal)
        const pwErrorResult = validateDeviceAccountPassword(tmpVal, inventoryName);
        setUserPWError(pwErrorResult.valid ? "" : pwErrorResult.msg);
        break;
      default:
        break;
    }
  }

  const updateInventory = async (item) => {
    setNowUuid(updateInventoryUuid)

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpResource = '/ents/:entId/orgs/:orgId/settings/inventoryDeviceAccount.update';
    let tmpParam = { username: inventoryName, password: inventoryPW };
    let tmpResourceAPIval = {
      entId: tmpSelectedBread.realm.id,
      orgId: tmpSelectedBread.orgs.id
    }

    sendRequest(tmpResource, updateInventoryUuid, tmpResourceAPIval, { param: tmpParam });
  }

  const isGeneralSaveDisabled = () => {
    const hasChanges =
      scopeName !== originalInfoData.orgName ||
      selectCountry?.value !== originalCountryDomainData?.value ||
      selectTimezoneData?.value !== originalTimezoneData?.value ||
      JSON.stringify(ntpServers) !== JSON.stringify(originalNtpServers) ||
      inventoryName !== originalInventoryDeviceAccountData.userName ||
      inventoryPW !== originalInventoryDeviceAccountData.password;

    return !scopeName.trim() || !inventoryName || Boolean(userError) ||
      !inventoryPW || Boolean(userPWError) || !hasChanges;
  }

  const handleCancelGeneral = () => {
    setScopeName(originalInfoData.orgName);
    setSelectCountry(originalCountryDomainData);
    setTimezoneList(originalTimezoneList)
    setSelectTimezoneData(originalTimezoneData);
    setNtpServers(originalNtpServers);
    setInventoryName(originalInventoryDeviceAccountData.username)
    setInventoryPW(originalInventoryDeviceAccountData.password)
    setUserError('')
    setUserPWError('')
  }

  const handleSaveGeneral = () => {
    // if(!showEditGeneral || checkMockup === 'true'){ return; }

    // if(isEmpty(scopeName)){
    //   setCheckScopeName(false)
    //   return;
    // }else{
    //   setCheckScopeName(true)
    // }

    // let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    // let tmpItem = cloneDeep(tmpSelectedBread.orgs)
    // tmpItem.name = scopeName;
    // updateManageOrg(tmpItem)

    if (isGeneralSaveDisabled()) {
      return;
    }

    const tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    const restfulParams = {
      entId: tmpSelectedBread.realm.id,
      orgId: tmpSelectedBread.orgs.id
    }
    const requestParams = {
      data: {
        info: {
          "orgId": originalInfoData.orgId,
          "orgName": scopeName,
        },
        countryDomain: {
          "countryIndex": selectCountry.value
        },
        timeConfig: {
          "timezone": selectTimezoneData.value,
          "ntpServer1": ntpServers[0] || "",
          "ntpServer2": ntpServers[1] || null,
          "ntpServer3": ntpServers[2] || null,
        },
        inventoryDeviceAccount: {
          "userName": inventoryName,
          "password": inventoryPW
        }
      }
    }
    sendRequest("/ents/:entId/orgs/:orgId/settings/general.update", updateOrgGeneralUuid, restfulParams, requestParams);
  }

  // dataMap 先分開做 未來有機會一次整合全部的 dataMap 行為
  useEffect(() => {
    const response = getData(updateOrgGeneralUuid);
    if (response) {
      setOriginalInfoData((pre) => ({ ...pre, orgName: scopeName }))

      let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
      tmpSelectedBread.orgs.name = scopeName;
      localStorage.setItem('selectBreadcrumbs', JSON.stringify(tmpSelectedBread));

      // The breadcrumb reads the selected organization from scopeData.
      setScopeData((prev) => ({
        ...prev,
        orgs: (prev.orgs || []).map((item) =>
          item.id === tmpSelectedBread.orgs.id
            ? { ...item, name: scopeName }
            : item,
        ),
      }));

      setOriginalCountryDomainData(selectCountry)
      setOriginalTimezoneList(timezoneList)
      setOriginalTimezoneData(selectTimezoneData)
      setOriginalNtpServers(ntpServers)
      setOriginalInventoryDeviceAccountData({ userName: inventoryName, password: inventoryPW })
    }
  }, [dataMap])

  const handleDeleteSetting = () => {
    setModalTitle('Delete ' + scopeName)
    setModalContent('Enter your password to delete all settings.')
    setModalSaveBtn('Delete')
    setModalCancelBtn('Cancel')
    setOpenModalConfirmPw(true)
  }

  const handleLeaveSetting = () => {
    setModalTitle('Leave ' + scopeName)
    setModalContent('Are you sure you want to leave?')
    setModalSaveBtn('Leave')
    setModalCancelBtn('Cancel')
    setModalFrom('check')
    setOpenModalCheck(true)
  }

  const updateManageOrg = async (item) => {
    setNowUuid(updateNameUuid)

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpResource = '';
    let tmpParam = '';
    let tmpCaptcha = 'inactive'
    let tmpResourceAPIval = {
      entId: tmpSelectedBread.realm.id,
      orgId: item.id
    }
    // tmpResource = "/ents/"+tmpSelectedBread.realm.id+"/orgs/"+item.id;
    tmpResource = "/ents/:entId/orgs/:orgId.update";
    tmpParam = {
      orgName: item.name,
      captcha: tmpCaptcha
    }

    sendRequest(tmpResource, updateNameUuid, tmpResourceAPIval, { param: tmpParam });
  };

  const delManageOrg = async (item) => {
    setNowUuid(deleteNameUuid)

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpResource = '/ents/:entId/orgs/:orgId.delete'
    // tmpResource = "/ents/"+tmpSelectedBread.realm.id+"/orgs/"+item.id;
    let tmpResourceAPIval = {
      entId: tmpSelectedBread.realm.id,
      orgId: item.id
    }

    sendRequest(tmpResource, deleteNameUuid, tmpResourceAPIval);
  };

  const leaveManageOrg = async (item) => {
    setNowUuid(leaveNameUuid)

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpResource = '/ents/:entId/orgs/:orgId/leave.update'
    // tmpResource = "/ents/"+tmpSelectedBread.realm.id+"/orgs/"+item.id+"/leave";
    let tmpResourceAPIval = {
      entId: tmpSelectedBread.realm.id,
      orgId: item.id
    }

    sendRequest(tmpResource, leaveNameUuid, tmpResourceAPIval);
  };

  // mockup 這段會有問題會進不來 初步判斷 nowUuid 會在某一個 side effect 變成空字串 導致進不來
  // 待重構
  useEffect(() => {
    if (nowUuid !== '') {
      // console.log(dataMap[nowUuid])
      switch (nowUuid) {
        case readInventoryUuid:
          if (dataMap[readInventoryUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[readInventoryUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[readInventoryUuid]?.data !== undefined) {
            let tmpData = dataMap[readInventoryUuid].data;
            setInventoryName(tmpData.username)
            setInventoryPW(tmpData.password)
          }
          setNowUuid('')
          break;
        case updateInventoryUuid:
          if (dataMap[updateInventoryUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[updateInventoryUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[updateInventoryUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('Your setting has been updated sucessfully.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('refresh')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        case updateNameUuid:
          if (dataMap[updateNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[updateNameUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[updateNameUuid] !== undefined) {
            let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
            tmpSelectedBread.orgs.name = scopeName;
            localStorage.setItem('selectBreadcrumbs', JSON.stringify(tmpSelectedBread));

            const targetScope = cloneDeep(scopeData.orgs);
            const updateScope = targetScope.map(item =>
              item.id === tmpSelectedBread.orgs.id ? { ...item, name: scopeName } : item
            );
            setScopeData(prev => ({
              ...prev,
              orgs: updateScope
            }))
          }
          setNowUuid('')
          updateInventory()
          break;
        case deleteNameUuid:
          if (dataMap[deleteNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[deleteNameUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[deleteNameUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('It will redirect to the realm home page later.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('navigate')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        case leaveNameUuid:
          if (dataMap[leaveNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[leaveNameUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[leaveNameUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('It will redirect to the realm home page later.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('navigate')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        default:
          break;
      }
    }
  }, [dataMap]);

  const handleShowDevicePw = (e) => {
    let tmpVal = showDevicePw;
    setShowDevicePw(!tmpVal)
  }

  const handleCheckModalAction = (value) => {
    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    if (value === 'ok') {
      if (modalFrom === 'check') {
        let tmpItem = cloneDeep(tmpSelectedBread.orgs)
        leaveManageOrg(tmpItem)
      } else if (modalFrom === 'navigate') {
        // navigate("/realms");
        let tmpScope = cloneDeep(scopeData)
        tmpScope.orgs = []
        setScopeData(tmpScope)
        let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
        tmpSelectedBread.orgs = {}
        localStorage.setItem('selectBreadcrumbs', JSON.stringify(tmpSelectedBread));
        setBread(tmpSelectedBread);

        navigate("/msp/organizations");
      } else if (modalFrom === 'refresh') {
        // window.location.reload();
      }
    }
  }

  const handlePasswordModalAction = (value) => {
    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    if (value === 'ok') {
      let tmpItem = cloneDeep(tmpSelectedBread.orgs)
      delManageOrg(tmpItem)
    }
  }

  const isEmpty = (val) => {
    return val == null || val.trim() === '';
  };

  return (
    <>
      <div className={mainStyle["anchorArea"]}>
        <div className={mainStyle["anchorBody"]}>
          {
            showEditGeneral && <Box>
              <div
                className={mainStyle["anchorItem"]}
                style={{
                  backgroundColor: nowAnchor === "notifications" ? theme.palette.primary.main : "",
                  cursor: "pointer",
                }}
                onClick={() => handleAnchor("notifications")}
              >
                <img
                  src={nowAnchor === "notifications" ? btn_alert_light : btn_alert}
                  alt="notifications"
                  style={{ width: "40px" }}
                />
                <span
                  className={mainStyle["anchorItem_text"]}
                  style={{
                    color:
                      nowAnchor === "notifications"
                        ? theme.palette.primary.white
                        : theme.palette.primary.main,
                  }}
                >
                  Notifications
                </span>
              </div>
              <Divider
                orientation="horizontal"
                sx={{
                  borderColor: theme.palette.primary.greyThread,
                  height: "2px",
                }}
              />
            </Box>
          }
          <Box onClick={() => { handleAnchor('account') }}>
            <div className={mainStyle["anchorItem"]} style={{ backgroundColor: (nowAnchor === 'account') ? theme.palette.primary.main : '' }}>
              <img src={(nowAnchor === 'account') ? btn_general_light : btn_general} style={{ width: '40px' }} />
              <span className={mainStyle["anchorItem_text"]} style={{ color: (nowAnchor === 'account') ? theme.palette.primary.white : theme.palette.primary.main }}>General</span>
            </div>
          </Box>
        </div>
      </div>
      <div className={mainStyle["userArea"]}>
        <Grid style={{ marginBottom: '20px' }}>
          <Box id="section1" >
            {/* style={{height:'1200px'}}  */}
            {(nowAnchor === 'account') ?
              <>
                <div className={mainStyle["titleArea"]}>
                  <Typography
                    variant="h4"
                    sx={{
                      mb: 2, ml: 1, mt: 2,
                      color: theme.palette.primary.main,
                      fontFamily: theme.typography.fontFamily,
                      fontSize: theme.typography.customFontSize[5],
                      fontWeight: theme.typography.customFontWeight[3],
                    }}
                  >
                    General Settings
                  </Typography>
                </div>
                <div className={mainStyle["contentArea"]}>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      {nowScope} Name
                    </Typography>
                    {!showEditGeneral &&
                      <Typography
                        sx={{
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                        style={{ marginLeft: '10px' }}
                      >{scopeName}
                      </Typography>
                    }
                    {showEditGeneral &&
                      <TextField
                        value={scopeName}
                        size="small"
                        onChange={(e) => handleInput(e, 'scopeName')}
                        variant="outlined"
                        error={!checkScopeName}
                        inputProps={{
                          style: {
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }
                        }}
                        sx={{
                          mr: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px', // 改變圓角
                            height: "29px",
                            '& fieldset': {
                              borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                            },
                            "&:hover fieldset": {
                              borderColor: theme.palette.primary.mainHover,
                            },
                            "&.Mui-focused fieldset": {
                              border: '1px solid',
                              borderColor: theme.palette.primary.main,
                            },
                          },
                        }}
                        style={{ width: '325px', paddingLeft: '10px', }}
                      />
                    }
                  </Grid>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      Select Country
                    </Typography>
                    {!showEditGeneral &&
                      <Typography
                        sx={{
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                        style={{ marginLeft: '10px' }}
                      >
                        {(selectCountry && selectCountry.label) || '-'}
                      </Typography>
                    }
                    {showEditGeneral &&
                      <Box sx={{ marginLeft: '10px' }}>
                        <AutocompleteSelect
                          width="318px"
                          placeholder="Select a Country"
                          options={selectCountryList}
                          value={selectCountry}
                          setValue={setSelectCountry}
                        />
                      </Box>
                    }
                  </Grid>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      Time Zone
                    </Typography>
                    {!showEditGeneral &&
                      <Typography
                        sx={{
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                        style={{ marginLeft: '10px' }}
                      >
                        {(selectTimezoneData && selectTimezoneData.value) || '-'}
                      </Typography>
                    }
                    {showEditGeneral &&
                      <Box sx={{ marginLeft: '10px' }}>
                        <MenuSelect
                          width="318px"
                          placeholder="Select a Time Zone"
                          value={selectTimezoneData && selectTimezoneData.value}
                          onChange={(opt) => setSelectTimezoneData(opt)}
                          options={timezoneList}
                        />
                      </Box>
                    }
                  </Grid>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      NTP Server
                    </Typography>
                    {!showEditGeneral &&
                      <Typography
                        sx={{
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                        style={{ marginLeft: '10px' }}
                      >
                        {ntpServers[0] || "-"}
                      </Typography>
                    }
                    {showEditGeneral &&
                      <TextField
                        value={ntpServers[0] || ""}
                        size="small"
                        onChange={(e) => handleChangeNtpServer(e.target.value, 0)}
                        variant="outlined"
                        inputProps={{
                          style: {
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }
                        }}
                        sx={{
                          mr: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            height: "29px",
                            '& fieldset': {
                              borderColor: theme.palette.primary.greyFifth,
                            },
                            "&:hover fieldset": {
                              borderColor: theme.palette.primary.mainHover,
                            },
                            "&.Mui-focused fieldset": {
                              border: '1px solid',
                              borderColor: theme.palette.primary.main,
                            },
                          },
                        }}
                        style={{ width: '325px', paddingLeft: '10px', }}
                        autoComplete="off"
                      />
                    }
                  </Grid>
                  {ntpServers.map((val, index) => {
                    if (index === 0) return null;

                    return (
                      <Grid container className={mainStyle['optionArea']} key={index}>
                        <Typography sx={{ width: "190px" }} />

                        {!showEditGeneral &&
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                            style={{ marginLeft: '10px' }}
                          >
                            {val}
                          </Typography>
                        }
                        {showEditGeneral && <>
                          <TextField
                            size="small"
                            value={val}
                            onChange={(e) => handleChangeNtpServer(e.target.value, index)}
                            variant="outlined"
                            inputProps={{
                              style: {
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[2],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }
                            }}
                            sx={{
                              mr: 1,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                height: "29px",
                                "& fieldset": {
                                  borderColor: theme.palette.primary.greyFifth,
                                },
                                "&:hover fieldset": {
                                  borderColor: theme.palette.primary.mainHover,
                                },
                                "&.Mui-focused fieldset": {
                                  border: "1px solid",
                                  borderColor: theme.palette.primary.main,
                                },
                              },
                            }}
                            style={{ width: "295px", paddingLeft: "10px" }}
                            autoComplete="off"
                          />

                          <StyledIconButton onClick={() => handleDeleteNtpServer(index)}>
                            <UnverifiedIcon />
                          </StyledIconButton>
                        </>
                        }
                      </Grid>
                    );
                  })}
                  {showEditGeneral &&
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <Typography sx={{ width: '450px' }} />
                      <OutlineRectangleButton
                        onMouseEnter={() => setIsAddHovered(true)}
                        onMouseLeave={() => setIsAddHovered(false)}
                        startIcon={
                          isAddHovered ? <AddHoverIcon /> : <AddIcon />
                        }
                        width="54px"
                        height="28px"
                        onClick={handleAddNtpServer}
                        disabled={ntpServers.length >= 3}
                      >
                        Add
                      </OutlineRectangleButton>
                    </Grid>
                  }
                </div>
                <div className={mainStyle["titleArea"]}>
                  <Typography
                    variant="h4"
                    sx={{
                      mb: 2, ml: 1, mt: 2,
                      color: theme.palette.primary.main,
                      fontFamily: theme.typography.fontFamily,
                      fontSize: theme.typography.customFontSize[5],
                      fontWeight: theme.typography.customFontWeight[3],
                    }}
                  >
                    Inventory Device Account
                  </Typography>
                </div>
                <div className={mainStyle["contentArea"]}>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      Username
                      <Typography component="span" sx={{ color: theme.palette.primary.redPrimary }}>
                        *
                      </Typography>
                    </Typography>
                    {!showEditGeneral &&
                      <Typography
                        sx={{
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                        style={{ marginLeft: '10px' }}
                      >{inventoryName}
                      </Typography>
                    }
                    {showEditGeneral &&
                      <TextField
                        value={inventoryName}
                        size="small"
                        onChange={(e) => handleInput(e, 'inventoryName')}
                        variant="outlined"
                        error={userError}
                        inputProps={{
                          style: {
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }
                        }}
                        sx={{
                          mr: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px', // 改變圓角
                            height: "29px",
                            '& fieldset': {
                              borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                            },
                            "&:hover fieldset": {
                              borderColor: theme.palette.primary.mainHover,
                            },
                            "&.Mui-focused fieldset": {
                              border: '1px solid',
                              borderColor: theme.palette.primary.main,
                            },
                          },
                        }}
                        style={{ width: '325px', paddingLeft: '10px', }}
                      />
                    }
                  </Grid>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
                      >
                        Password
                        <Typography component="span" sx={{ color: theme.palette.primary.redPrimary }}>
                          *
                        </Typography>
                        <Tooltip
                          title={passwordRequirementsTip}
                          arrow
                          placement="top"
                          componentsProps={{
                            tooltip: {
                              sx: { maxWidth: 360, p: "12px 14px", bgcolor: "#5f5f5f" },
                            },
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              width: 16,
                              "& img": { content: `url(${infoTipIcon})` },
                              "&:hover img": { content: `url(${infoTipHoverIcon})` },
                            }}
                          >
                            <img src={infoTipIcon} alt="" style={{ width: 16, height: 16, cursor: "pointer" }} />
                          </Box>
                        </Tooltip>
                      </Box>
                    </Typography>
                    {!showEditGeneral &&
                      <Box sx={{ display: "flex" }}>
                        <Typography
                          sx={{
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }}
                          style={{ marginLeft: '10px' }}
                        >{showDevicePw ? inventoryPW : '•'.repeat(inventoryPW?.length || 8)}
                        </Typography>
                        <Box sx={{ marginLeft: "8px" }}>
                          <StyledIconButton onClick={handleShowDevicePw}>
                            {!showDevicePw ? <HideIcon /> : <ShowIcon />}
                          </StyledIconButton>
                        </Box>
                      </Box>
                    }
                    {showEditGeneral &&
                      <TextField
                        value={inventoryPW}
                        size="small"
                        onChange={(e) => handleInput(e, 'inventoryPW')}
                        variant="outlined"
                        error={userPWError}
                        inputProps={{
                          style: {
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }
                        }}
                        type={showDevicePw ? 'text' : 'password'}
                        sx={{
                          mr: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px', // 改變圓角
                            height: "29px",
                            '& fieldset': {
                              borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                            },
                            "&:hover fieldset": {
                              borderColor: theme.palette.primary.mainHover,
                            },
                            "&.Mui-focused fieldset": {
                              border: '1px solid',
                              borderColor: theme.palette.primary.main,
                            },
                          },
                        }}
                        style={{ width: '325px', paddingLeft: '10px', }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {!showDevicePw && <HideIcon onClick={handleShowDevicePw} style={{ cursor: 'pointer' }} />}
                              {showDevicePw && <ShowIcon onClick={handleShowDevicePw} style={{ cursor: 'pointer' }} />}
                            </InputAdornment>
                          ),
                        }}
                      />
                    }
                  </Grid>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[1],
                        fontWeight: theme.typography.customFontWeight[1],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    />
                    {userPWError &&
                      <Typography
                        sx={{
                          fontSize: theme.typography.customFontSize[3],
                          color: theme.palette.primary.redPrimary,
                        }}
                        style={{ marginLeft: '10px' }}
                      >{userPWError}
                      </Typography>
                    }
                  </Grid>
                  {showLeaveGeneral &&
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <LeaveIcon onClick={() => handleLeaveSetting()} style={{ cursor: 'pointer', marginRight: '5px' }} />
                      <Typography
                        onClick={() => handleLeaveSetting()}
                        style={{ cursor: 'pointer' }}
                        sx={{
                          width: '190px',
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[1],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      >
                        Leave {nowScope}
                      </Typography>
                    </Grid>
                  }
                  {showDeleteGeneral &&
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <RemoveIcon onClick={() => handleDeleteSetting()} style={{ cursor: 'pointer', margin: '0 6px 0 2px' }} />
                      <Typography
                        onClick={() => handleDeleteSetting()}
                        style={{ cursor: 'pointer' }}
                        sx={{
                          width: '190px',
                          color: theme.palette.primary.redPrimary,
                          fontSize: theme.typography.customFontSize[1],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      >
                        Delete {nowScope}
                      </Typography>
                    </Grid>
                  }
                </div>
                {showEditGeneral && <Box>
                  <Grid container style={{ justifyContent: 'center', width: '100%' }}>
                    <Box style={{ margin: '10px' }}>
                      <OutlineButton width="135px" height="42px" onClick={() => handleCancelGeneral()}
                        disabled={showEditGeneral ? false : true}>
                        Cancel
                      </OutlineButton>
                    </Box>
                    <Box style={{ margin: '10px' }}>
                      <SolidButton width="135px" height="42px" onClick={() => handleSaveGeneral()}
                        disabled={isGeneralSaveDisabled()}>
                        Save
                      </SolidButton>
                    </Box>
                  </Grid>
                </Box>}
              </>
              :
              <></>
            }
            {nowAnchor === "notifications" && <Notifications showEditGeneral={showEditGeneral} />}
          </Box>
        </Grid>
      </div>

      <ModalContainer
        display={openModalCheck}
        modalWidth={'550px'} //550px, 750px, empty=1000px,
        children={
          <ModalforCheck
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalCheck}
            onBottonClick={handleCheckModalAction}
          />
        }
      />
      <ModalContainer
        display={openModalConfirmPw}
        modalWidth={'500px'} //550px, 750px, empty=1000px,
        children={
          <ModalConfirmPw
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalConfirmPw}
            originUser={originUser}
            onBottonClick={handlePasswordModalAction}
          />
        }
      />
    </>
  );
};

export default ManageOrgLevel;
